import React from "react";
import { Layout } from "./shared/Layout";
import { Title } from "./shared/Title";
import { not } from "../../../../utilities/fp";
import { getIsConstantContactIntegrationAccessible } from "../../../../helpers/integrations";
import { useIntegration } from "./hooks/useIntegration";
import { ContentWrapper } from "./shared/ContentWrapper";
import { Authorize } from "./shared/Authorize";
import { Settings } from "./shared/Settings";

export function ConstantContact() {
  const isIntegrationAccessible = getIsConstantContactIntegrationAccessible();

  const {
    isEnabled,
    setIsEnabled,
    syncAll,
    setSyncAll,
    syncNew,
    setSyncNew,
    date,
    isLoading,
    onAuthorize,
  } = useIntegration();

  return (
    <Layout isLoading={isLoading}>
      <Title isEnabled={isEnabled} onToggle={() => setIsEnabled(not)} />
      {isEnabled && isIntegrationAccessible && (
        <ContentWrapper>
          <Authorize authorizedOn={date} onAuthorize={onAuthorize} />
          <Settings
            syncAll={syncAll}
            setSyncAll={setSyncAll}
            syncNew={syncNew}
            setSyncNew={setSyncNew}
          />
        </ContentWrapper>
      )}
    </Layout>
  );
}
